import { render, staticRenderFns } from "./allNumber-detail.vue?vue&type=template&id=3f259221"
import script from "./allNumber-detail.vue?vue&type=script&lang=js"
export * from "./allNumber-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports